<template>
  <div>
    <popup-hint hint="vesselsreconcile">
      <template v-slot:breadcrumbs>
        <breadcrumbs :back="[{text:type==='Tank'?'Tanks':'Bulk containers',to:{name:type==='Tank'?'EquipmentTanks':'InventoryBulkContainers',query:{siteId:filters.siteId}}}]" home="Reconciliations"/>
      </template>
      <template v-slot:top>
        Reconcile all your {{type==='Tank'?'Tanks':'Bulk containers'}} inventory in a single operation.
      </template>
    </popup-hint>

    <purtrak-table name="vesselreconciliations" objectType="reconciliations" :defaultColumns="defaultColumns" :headers="headers" ref="table" show-expand
                   listEndPoint="exciseVesselReconciliations2"
                   fields="id,date,user,site{id,name},draft"
                   :listFilters="listFilters"
                   @dblclick="reconciliation => $router.push({name:reconciliation.draft?'ExciseVesselReconcileEdit':'ExciseVesselReconcileTransactions',params:{id:reconciliation.id}})"
                   :item-class="reconciliation => (reconciliation.draft ? 'warning--text' : '')"
                   @itemExpanded="({item, value}) => expandReconciliation(item, value)"
                   title="Reconciliations"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[dateDisplay, filters.draft?'Draft':null]}"
                   download-endpoint="exciseVesselReconciliationsExportCSV">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.siteId=null;filters.draft='0';filters.from=null;filters.to=null">
          <v-list-item>
            <date-range :from.sync="filters.from" :to.sync="filters.to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
          <v-list-item dense>
            <v-checkbox v-model="filters.draft" true-value="1" false-value="0" label="Show draft only" class="mt-0"/>
          </v-list-item>
          <v-list-item v-if="sites.length>1">
            <v-autocomplete label="Site" dense outlined :items="[{id:null,name:'All'},{divider:true},...sites]" v-model="filters.siteId" item-text="name" item-value="id"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.from!=null" close small class="ml-1" @click:close="filters.from=null;filters.to=null">{{dateDisplay}}</v-chip>
          <v-chip v-show="filters.draft=='1'" close small class="ml-1" @click:close="filters.draft='0'">Draft only</v-chip>
          <v-chip v-show="filters.siteId!=null" close small class="ml-1" @click:close="filters.siteId=null">{{siteName}}</v-chip>
        </template>
      </template>
      <template v-slot:menu v-if="!readOnly">
        <v-list-item :to="{name:'ExciseVesselReconcileEditNew'}"><v-list-item-title>Create reconciliation</v-list-item-title></v-list-item>
      </template>

      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'ExciseVesselReconcileEditNew'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
        <v-icon v-if="!item.draft" @click="expand(!isExpanded)">{{isExpanded?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
      </template>
      <template v-slot:item.date="{value}">
        {{value | formatDateTime}}
      </template>
      <template v-slot:item.draft="{value}">
        <v-icon v-if="value">mdi-check</v-icon>
      </template>
      <template v-slot:expanded-item="{ item, headers }">
        <td :colspan="headers.length">
          <v-card class="my-4 text-caption" :class="expansionPanelClass">
            <v-simple-table dense class="my-2" :class="expansionPanelClass" style="width:100%">
              <thead>
                <tr>
                  <th :class="expansionPanelClass" width="30%">{{type==='Tank'?'Tank':'Bulk container'}}</th>
                  <th :class="expansionPanelClass" width="30%">Action</th>
                  <th class="text-right" :class="expansionPanelClass" width="15%">Volume</th>
                  <th class="text-right" :class="expansionPanelClass" width="15%">Value</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="transaction of item.transactions" :key="transaction.id">
                  <td class="text-caption">{{transaction.name}}</td>
                  <td class="text-caption">
                    <a @click="$router.push({name:'ExciseVesselAdjustInventory',params:{transactionId:transaction.id}})">
                      {{transaction.description}}
                    </a>
                  </td>
                  <td class="text-caption text-right">{{transaction.volume | number(3)}} {{transaction.units}}</td>
                  <td class="text-caption text-right">{{transaction.value | currency}}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </td>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Reconciliation operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item :to="{name:item.draft?'ExciseVesselReconcileEdit':'ExciseVesselReconcileTransactions',params:{id:item.id}}"><v-list-item-title>{{item.draft?'Edit':'View transactions'}}</v-list-item-title></v-list-item>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item @click="reconciliation=item;showDelete=true"><v-list-item-title>Delete reconciliation</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" name="this reconciliation" @delete="performDeleteTransaction"/>
  </div>
</template>

<script>

export default {
  name: 'ExciseVesselReconcile',
	props: {
    type: {type:String,required:true},
	},
  data() {
    return {
      filters: {
        from: null,
        to: null,
        draft: '0',
        siteId: null
      },
      dateDisplay: '',
      reconciliation: null,
      showDelete: false,
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'user', visible:true},
                       { value: 'site.name', visible:true},
                       { value: 'draft', visible:true}],
      headers: [{ text: 'DATE', value: 'date', width:'20%',sortable:true},
                { text: 'USER', value: 'user', width:'40%',sortable:true},
                { text: 'SITE', value: 'site.name', width:'30%',sortable:true, omit:() => this.sites.length <= 1},
                { text: 'DRAFT', value: 'draft', width:'10%',sortable:true,align:'center'}]
    }
  },
  computed: {
    sites() {
      return this.$store.getters.sites(false, {B263:true,B265:true,B266:true});
    },
    siteName() {
      return this.sites.find(site => site.id === this.filters.siteId)?.name;
    },
    company() {
      return this.$store.getters.company;
    },
    readOnly() {
      return !this.company.permissions.includes('inventory.write');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    listFilters() {
      const filters = [];
      if (this.filters.from)
        filters.push({field:'date', comparator:'ge', value:`${this.filters.from} 00:00:00`});
      if (this.filters.to)
        filters.push({field:'date', comparator:'le', value:`${this.filters.to} 23:59:59`});
      if (this.filters.draft == 1)
        filters.push({field:'draft', comparator:'eq', value:'true'});
      if (this.filters.siteId !== null)
        filters.push({field:'siteId', comparator:'eq', value:this.filters.siteId});
      return filters;
    },
    back() {
      return [{text:'Items',to:{name:'InventoryItems',query:{siteId:this.filters.siteId}}}];
    }
  },
  methods: {
    async performDeleteTransaction() {
      this.loading = true;
      const results = await this.$apiCall(`mutation ExciseVesselReconcile($id: ID!) {
                                            objectDelete(id:$id)
                                          }`,
                                          {id:this.reconciliation.id});
      this.loading = false;
      if (!results.error) {
        this.showDelete = false;
        this.$refs.table?.buildList();
        this.$store.commit('setError', {type:'success',message:`Deleted reconciliation`});
      }
    },
    async expandReconciliation(item, value) {
      if (value && !item.transactions) {
        this.loading = true;
        const results = await this.$apiCall(`query ExciseVesselReconcile($id:ID!) {
                                                  exciseVesselReconciliation(id:$id) {
                                                    transactions {id,name,description,volume,units,value}
                                                  }
                                                }`,
                                            {id:item.id});
        this.$set(item, 'transactions', results.data.exciseVesselReconciliation.transactions);
        this.loading = false;
      }
    }
  }
}
</script>